document.addEventListener('DOMContentLoaded', function() {
    const discountTemplate = `
        <div class="black-friday-discount-banner" id="black-friday-discount-banner">
            <p><strong>25% OFF</strong> applied at checkout with code</p>
            <button type="button" class="black-friday-discount-code">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                    <path d="M8.0998 1.8C7.62241 1.8 7.16458 1.98965 6.82701 2.32721C6.48945 2.66478 6.2998 3.12261 6.2998 3.6V10.8C6.2998 11.2774 6.48945 11.7352 6.82701 12.0728C7.16458 12.4104 7.62241 12.6 8.0998 12.6H13.4998C13.9772 12.6 14.435 12.4104 14.7726 12.0728C15.1102 11.7352 15.2998 11.2774 15.2998 10.8V5.7726C15.2997 5.29525 15.11 4.83749 14.7724 4.5L12.5998 2.3274C12.2623 1.98981 11.8046 1.8001 11.3272 1.8H8.0998Z" fill="white"/>
                    <path d="M2.7002 7.19999C2.7002 6.7226 2.88984 6.26477 3.2274 5.9272C3.56497 5.58964 4.02281 5.39999 4.5002 5.39999V14.4H11.7002C11.7002 14.8774 11.5106 15.3352 11.173 15.6728C10.8354 16.0104 10.3776 16.2 9.9002 16.2H4.5002C4.02281 16.2 3.56497 16.0104 3.2274 15.6728C2.88984 15.3352 2.7002 14.8774 2.7002 14.4V7.19999Z" fill="white"/>
                </svg>
                BF25
            </button>
        </div>
    `

    function showBlackFridayAlert(
        message,
        {
            baseClass = 'black-friday-alert-box',
            textClassSuffix = '__text',
            activeClass = 'is-active',
            showDelay = 50,
            visibleDuration = 2500
        } = {}
    ) {
        const existing = document.querySelector(`.${baseClass}`);
        if (existing) existing.remove();

        const alertBox = document.createElement('div');
        alertBox.className = baseClass;

        const alertText = document.createElement('span');
        alertText.className = baseClass + textClassSuffix;
        alertText.textContent = message;

        alertBox.appendChild(alertText);
        document.body.appendChild(alertBox);

        requestAnimationFrame(() => {
            setTimeout(() => alertBox.classList.add(activeClass), showDelay);
        });

        setTimeout(() => {
            alertBox.classList.remove(activeClass);

            const onTransitionEnd = (event) => {
                if (event.target === alertBox) {
                    alertBox.removeEventListener('transitionend', onTransitionEnd);
                    alertBox.remove();
                }
            };
            alertBox.addEventListener('transitionend', onTransitionEnd);
        }, visibleDuration);
    }

    function copyDiscountCode() {
        const code = 'BF25';
        navigator.clipboard.writeText(code).then(function() {
            showBlackFridayAlert(`Discount code copied! Use ${code} at checkout.`);
        }, function(err) {
            console.error('Could not copy text: ', err);
            showBlackFridayAlert('Unable to copy the code. Please copy it manually.');
        });
    }

    function initBlackFridayBanner() {
        const elementsWhereBannerShouldAppear = ['#slidecart-checkout-form', '.product__page .productText .product_form'];
    
        elementsWhereBannerShouldAppear.forEach(selector => {
            const targetElement = document.querySelector(selector);
            if (!!!targetElement) return
    
            targetElement.insertAdjacentHTML('afterend', discountTemplate);
            const bannerElement = targetElement.nextElementSibling;
            const copyButton = bannerElement?.querySelector('.black-friday-discount-code');
            copyButton?.addEventListener('click', copyDiscountCode);
        });
    }

    function initBlackFridayHeroBanner() {
        const heroBannerBtn = document.querySelector('.hero-bf-banner__code-chip');
        if (!!!heroBannerBtn) return
        heroBannerBtn.addEventListener('click', copyDiscountCode);
    }

    setTimeout(initBlackFridayBanner, 1000);
    setTimeout(initBlackFridayHeroBanner, 200); 
});
